export * from "connective/helpers/constants/images"
import { BACKGROUNDS } from "connective/helpers/constants/images"

BACKGROUNDS.welcome = require("@/assets/img/optimized/Manchi.webp")

export { BACKGROUNDS }
